const initialState = {
  muiTables: {}
}

function createTable (state, action) {
  state.muiTables[action.id] = {
    isLoading: true
  }
}

function updateTable (state, action) {
  state.muiTables[action.id] = {
    ...state.muiTables[action.id],
    ...action.newState
  }
}

function deleteTable (state, action) {
  delete state.muiTables[action.id]
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CREATE_MUITABLE':
      createTable(state, action)
      return { ...state }
    case 'DELETE_MUITABLE':
      deleteTable(state, action)
      return { ...state }
    case 'UPDATE_MUITABLE':
      updateTable(state, action)
      return { ...state }
    default:
      return { ...state }
  }
}
